<div class="menu-edit-dialog-container" *ngrxLet="isCreationMode$ | async as isCreationMode">
  <div class="gb-dialog-header edit-infobooth-toolbar">
    <h1>
      {{ 'SETTINGS.MENU.EDIT.TITLE' | translate }}
    </h1>
    <button mat-icon-button (click)="closeDialog()">
      <gb-icon icon="close"></gb-icon>
    </button>
  </div>
  <div class="gb-dialog-content">
    <form [formGroup]="editMenuOptionForm">
      @if (isCreationMode$ | async) {
        <gb-select-form-field
          [control]="button_type"
          [options$]="buttonTypeOptions$"
          valueProperty="value"
          displayProperty="display"
          labelTranslateKey="SETTINGS.MENU.EDIT.BUTTON_TYPE"
          (onOptionSelected)="onButtonTypeSelected($event)"
        ></gb-select-form-field>
      }

      <!-- button type specific fields -->

      @if (button_type?.value) {
        <div>
          @switch (button_type?.value) {
            <!-- infobooth fields -->
            @case (MenuItemsButtonTypesEnum.Infobooth) {
              <gb-select-form-field
                [control]="infobooth"
                [options$]="allInfobooths$"
                valueProperty="uuid"
                displayProperty="name"
                labelTranslateKey="SETTINGS.MENU.EDIT.INFOBOOTH"
              ></gb-select-form-field>
            }
            <!-- old widget pages fields -->
            @case (MenuItemsButtonTypesEnum.Hub) {
              <gb-select-form-field
                [control]="hub"
                [options$]="allOldWidgets$"
                valueProperty="uuid"
                displayProperty="name"
                labelTranslateKey="SETTINGS.MENU.EDIT.HUB"
              ></gb-select-form-field>
            }
            <!-- widget pages fields -->
            @case (MenuItemsButtonTypesEnum.WidgetPage) {
              <gb-select-form-field
                [control]="widget_page"
                [options$]="allHubs$"
                valueProperty="uuid"
                displayProperty="name"
                labelTranslateKey="SETTINGS.MENU.EDIT.WIDGET_PAGE"
              ></gb-select-form-field>
            }
            <!-- categories fields -->
            @case (MenuItemsButtonTypesEnum.Category) {
              <gb-select-form-field
                [control]="category"
                [options$]="allCategories$"
                valueProperty="uuid"
                displayProperty="label"
                labelTranslateKey="SETTINGS.MENU.EDIT.CATEGORY"
              ></gb-select-form-field>
            }
            <!-- item fields -->
            @case (MenuItemsButtonTypesEnum.Item) {
              <gb-item-select
                [control]="item"
                (selectedOptionChanged)="setItem($event)"
                (selectedOptionClear)="clearItem()"
                labelTranslateKey="SETTINGS.MENU.EDIT.ITEM"
              ></gb-item-select>
            }
            @case (MenuItemsButtonTypesEnum.ItemType) {
              <div>
                <span
                  translate="SETTINGS.MENU.EDIT.ITEM_TYPE"
                  [translateParams]="{
                    item_type: getItemTypeTranslationKey(item_type?.value),
                  }"
                ></span>
              </div>
            }
            <!-- external link fields -->
            @case (MenuItemsButtonTypesEnum.ExternalLink) {
              <gb-form-field labelTranslateKey="SETTINGS.MENU.EDIT.URL" [control]="url"> </gb-form-field>
              <mat-checkbox [formControl]="external_link">{{
                'SETTINGS.MENU.EDIT.OPEN_NEW_TAB' | translate
              }}</mat-checkbox>
            }
          }
        </div>
      }

      <gb-form-field [control]="label" labelTranslateKey="SETTINGS.MENU.EDIT.LABEL"></gb-form-field>

      @if (!isAccountType) {
        <mat-checkbox [formControl]="is_visible">{{ 'SETTINGS.MENU.EDIT.VISIBILITY' | translate }}</mat-checkbox>
      }

      @if (!is_visible.value && menuPageLink) {
        <div class="callout" @fadeUp>
          <div class="copy-container">
            <span class="copy-text" (click)="openUrl(menuPageLink)">{{ menuPageLink }}</span>
            <div (click)="copyUrl(menuPageLink)" class="copy-icon">
              <gb-icon height="18px" icon="copy"></gb-icon>
            </div>
          </div>
        </div>
      }

      <gb-icon-picker [displayIcon]="icon && icon.value" (selectIcon)="onIconSelect($event)"></gb-icon-picker>
    </form>
  </div>
  <div class="gb-flex-button-container gb-dialog-actions-container">
    <button (click)="submitForm(!!isCreationMode)" mat-flat-button>
      <gb-button-loader [loaded$]="editCreateLoaded$">
        <span> {{ 'SETTINGS.MENU.EDIT.SUBMIT' | translate }}</span>
      </gb-button-loader>
    </button>
  </div>
</div>
